const TRUST_ITEMS = [
  { index: "01", label: "Hook to Holders", detail: "First v4 hook routing pool fees to NFTs, not LP" },
  { index: "02", label: "AI fossilized", detail: "Three hashes prove which AI drew this, forever" },
  { index: "03", label: "AI handoff", detail: "Public Skill handoff gates every mint" },
  { index: "04", label: "Stakeless yield", detail: "Hold the receipt. No vault. No lockup." },
  { index: "00", label: "0 admin after finalize", detail: "No pause, no upgrade, no buyback. Ever." }
] as const;

export default function TrustBar() {
  return (
    <div className="trust-bar" aria-label="CODE APE trust summary">
      {TRUST_ITEMS.map((item) => (
        <div key={item.label} className="trust-bar__item">
          <span className="trust-bar__index">{item.index}</span>
          <strong>{item.label}</strong>
          <span>{item.detail}</span>
        </div>
      ))}
    </div>
  );
}
